import { z } from 'zod';

/**
 * Structured evidence reference. Material statements in outputs carry SourceRefs, never
 * formatted strings. `kind` is an open string so domain packs can add source kinds without
 * changing Core; the Core-known kinds are listed here.
 */
export const CORE_SOURCE_KINDS = [
  'knowledge_item',
  'source_document',
  'execution',
  'tool_result',
  'human_input',
] as const;

export const SourceRef = z.object({
  kind: z.string().min(1),
  id: z.string().min(1),
  /** Connection name that produced the source, e.g. "jira-main". */
  connection: z.string().optional(),
  version: z.string().optional(),
  locator: z
    .object({
      section: z.string().optional(),
      anchor: z.string().optional(),
      page: z.number().int().positive().optional(),
    })
    .optional(),
  /** Only present when policy allows exposing the source URL. */
  url: z.url().optional(),
  retrievedAt: z.iso.datetime(),
  authorityClass: z.string().optional(),
  /** SHA-256 of the quoted span used as evidence. */
  quoteHash: z.string().optional(),
});
export type SourceRef = z.infer<typeof SourceRef>;
